import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import Breadcrumb from 'component/Breadcrumb'
import ContentHeader from 'component/utils/ContentHeader'
import Table from 'component/justificationDisapprovalUseAndConsumption/Table'
import Form from 'component/justificationDisapprovalUseAndConsumption/Form'
import Grid from 'component/utils/Grid'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'

import * as justificationActions from 'action/JustificationDisapprovalUseAndConsumption'

class JustificationContainer extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    fetchList: PropTypes.func.isRequired,
    updateJustification: PropTypes.func.isRequired,
    removeJustification: PropTypes.func.isRequired,
    justifications: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
    error: PropTypes.object,
  }

  state = {
    justification: null,
    label: 'justification.disapproval.use.and.consumption.form.label.cad',
  }

  componentDidMount() {
    this.handleFetchJustification()
  }

  handleFetchJustification = (page) => {
    const {
      auth: { user },
      fetchList,
    } = this.props
    fetchList(user.dsToken, page)
  }

  updateJustificationIsActive = (justification) => {
    const {
      auth: { user },
      updateJustification,
    } = this.props
    const values = {
      ...justification,
      inInactive: justification.inInactive === 0 ? 1 : 0,
    }

    updateJustification(user.dsToken, values)
  }

  saveJustification = (values) => {
    const {
      auth: { user },
      updateJustification,
    } = this.props
    updateJustification(user.dsToken, values)
    this.setState({ justification: null })
  }

  handleEditJustification = (justification) => {
    this.setState({
      justification,
      label: justification
        ? 'justification.disapproval.use.and.consumption.form.label.alt'
        : 'justification.disapproval.use.and.consumption.form.label.cad',
    })
  }

  handleRemoveJustification = ({
    idJustificationDisapprovalUseConsumption,
  }) => {
    const {
      auth: { user },
      removeJustification,
    } = this.props

    removeJustification(user.dsToken, idJustificationDisapprovalUseConsumption)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      {
        title: translate(
          'justification.disapproval.use.and.consumption.step.2'
        ),
      },
      {
        title: translate('justification.disapproval.use.and.consumption.title'),
      },
    ]

    return <Breadcrumb steps={steps} />
  }

  renderPagination = () => {
    const { pages } = this.props

    if (!pages || pages < 2) {
      return null
    }

    const { current, count } = this.props

    return (
      <Col className='align-center margin-top'>
        <Pagination
          getPage={this.handleFetchJustification}
          pages={pages}
          current={current}
          count={count}
        />
      </Col>
    )
  }

  shouldRenderJustifications = () => {
    const { justifications } = this.props

    if (!justifications || justifications.length < 1) {
      return false
    }

    return true
  }

  render() {
    const { translate, justifications } = this.props
    return (
      <div>
        <ContentHeader>
          {translate('justification.disapproval.use.and.consumption.title')}
        </ContentHeader>
        {this.renderBreadcrumb()}
        <Grid fluid>
          <Col
            lg={6}
            lgOffset={3}
            md={6}
            mdOffset={3}
            sm={12}
            xs={12}
            className='margin-top'
          >
            <h4>
              {translate('justification.disapproval.use.and.consumption.title')}
            </h4>
          </Col>
          {this.shouldRenderJustifications() && (
            <div>
              <Col
                lg={6}
                lgOffset={3}
                md={6}
                mdOffset={3}
                sm={12}
                xs={12}
                className='align-center margin-top'
              >
                <Table
                  translate={translate}
                  justifications={justifications}
                  updateJustificationIsActive={this.updateJustificationIsActive}
                  editJustification={this.handleEditJustification}
                  removeJustification={this.handleRemoveJustification}
                />
              </Col>
              {this.renderPagination()}
            </div>
          )}

          <Form
            justification={this.state.justification}
            label={translate(this.state.label)}
            updateJustification={this.handleEditJustification}
            translate={translate}
            onSubmit={this.saveJustification}
          />
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = ({
  JustificationDisapprovalUseAndConsumptionReducer,
  paginateReducer,
}) => ({
  justifications: JustificationDisapprovalUseAndConsumptionReducer.list.records,
  error: JustificationDisapprovalUseAndConsumptionReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(justificationActions, dispatch)

const JustificationTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(JustificationContainer)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JustificationTranslated)

export { JustificationContainer }
